import React, { HTMLAttributes, useContext } from 'react';
import useStyles from './AccordionPanelHeader.styles';
import AccordionPanelContext from '../AccordionPanel/AccordionPanelContext';
import AccordionIcon from '../AccordionIcon/AccordionIcon';

export interface IAccordionPanelHeaderProps extends HTMLAttributes<HTMLDivElement> {
  /** Displays the Accordion Icon on the right side of the panel header */
  iconRight?: boolean;
}

const AccordionPanelHeaderComponent = ({
  children,
  className,
  iconRight,
}: IAccordionPanelHeaderProps) => {
  const { handleSetCurrentOpenPanelsIdsArr, isOpen, panelId } = useContext(AccordionPanelContext);
  const classes = useStyles(iconRight);
  return (
    <h3 className={className}>
      <button
        aria-controls={panelId}
        aria-disabled="false"
        aria-expanded={isOpen}
        className={classes.accordionHeader}
        onClick={() => handleSetCurrentOpenPanelsIdsArr!(panelId!)}
        type="button"
      >
        <AccordionIcon />
        <div className={classes.accordionHeaderContent}>
          {typeof children === 'string' ? <span>{children}</span> : children}
        </div>
      </button>
    </h3>
  );
};

AccordionPanelHeaderComponent.displayName = 'AccordionPanelHeader';

export default AccordionPanelHeaderComponent;
